// @ts-nocheck
import {
    COUPON_BANNER_ITEM_CHANGED,
    COUPON_BANNER_LIST_RECEIVED,
    COUPON_BANNER_PREVIEW_MODAL_PROPS_CHANGED,
} from '../../types';

const initialState = {
    list: [],
    current: null,
    previewModal: {
        isVisible: false,
        banner: null,
    },
};

const couponBanner = (state = initialState, action) => {
    const { payload } = action;

    switch (action.type) {
        case COUPON_BANNER_LIST_RECEIVED: {
            return {
                ...state,
                list: payload,
            };
        }
        case COUPON_BANNER_ITEM_CHANGED: {
            return {
                ...state,
                current: payload,
            };
        }
        case COUPON_BANNER_PREVIEW_MODAL_PROPS_CHANGED: {
            return {
                ...state,
                previewModal: payload,
            };
        }
        default: {
            return state;
        }
    }
};

export default couponBanner;
